import type {
  CompanyInsertPayload,
  CompanyRiskUpdatePayload,
  CompanyUpdatePayload,
} from "@asap/shared/schemas/company";
import type { CompanySuggestionListQuery } from "@asap/shared/schemas/company-suggestion";
import { useApi } from "~/composables/useApi";

export const useCompanyApi = () => {
  const { invoke } = useApi();

  const listCompanySuggestions = async (query: CompanySuggestionListQuery) => {
    const answer = await invoke({ path: "company-suggestions", method: "GET", query });
    if (!answer.success) throw new Error(answer.error.clientMessage ?? answer.error.message);
    return answer.data;
  };

  const createCompany = async (body: CompanyInsertPayload) => {
    const answer = await invoke({ path: "companies", method: "POST", body });
    if (!answer.success) throw new Error(answer.error.clientMessage ?? answer.error.message);
    return answer.data;
  };

  const getCompany = async (id: string) => {
    const answer = await invoke({ path: "companies/:id", method: "GET", params: { id } });
    if (!answer.success) throw new Error(answer.error.clientMessage ?? answer.error.message);
    return answer.data;
  };

  const updateCompany = async (id: string, body: CompanyUpdatePayload) => {
    const answer = await invoke({ path: "companies/:id", method: "PATCH", params: { id }, body });
    if (!answer.success) throw new Error(answer.error.clientMessage ?? answer.error.message);
    return answer.data;
  };

  const updateCompanyRisk = async (id: string, body: CompanyRiskUpdatePayload) => {
    const answer = await invoke({ path: "companies/:id/risk", method: "PATCH", params: { id }, body });
    if (!answer.success) throw new Error(answer.error.clientMessage ?? answer.error.message);
    return answer.data;
  };

  const getCreditInsuranceAccess = async () => {
    const answer = await invoke({ path: "credit-insurance/access", method: "GET" });
    if (!answer.success) throw new Error(answer.error.clientMessage ?? answer.error.message);
    return answer.data;
  };

  return {
    listCompanySuggestions,
    createCompany,
    getCompany,
    updateCompany,
    updateCompanyRisk,
    getCreditInsuranceAccess,
  };
};
